import { setGlobalSetting } from 'store';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { checkMobile } from 'lib/utils';

export const useInitial = (width = 0, height = 0) => {
  const dispatch = useDispatch();

  useEffect(() => {
    let acceptWidth = width;
    let acceptHeight = height;
    if (width > window.innerWidth) {
      acceptWidth = window.innerWidth - 24;
      acceptHeight = window.innerWidth - 24;
    }
    const [isMobile] = checkMobile(
      window.navigator.userAgent,
      window.innerWidth,
      window.innerWidth
    );

    dispatch(
      setGlobalSetting({
        width: acceptWidth,
        height: acceptHeight,
        isMobile,
      })
    );
  }, [dispatch]);
};
